import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { SentimentDissatisfied as SadIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
/**
 * Composant pour afficher un état vide (aucune donnée)
 * @param {Object} props - Propriétés du composant
 * @param {string} props.title - Titre du message d'état vide
 * @param {string} props.description - Description détaillée
 * @param {React.ReactNode} [props.icon] - Icône personnalisée (optionnelle)
 * @param {React.ReactNode} [props.action] - Élément d'action comme un bouton (optionnel)
 */
const EmptyState = ({ title, description, icon, action }) => {
     const { t } = useTranslation();
    return (
        <Paper
            elevation={0}
            sx={{
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                borderRadius: 2,
                bgcolor: 'background.default',
                minHeight: 200
            }}
        >
            <Box sx={{ mb: 2, color: 'text.secondary', fontSize: 60 }}>
                {icon || <SadIcon sx={{ fontSize: 60 }} />}
            </Box>

            <Typography variant="h6" gutterBottom>
            {title || t('common.noResults')}
            </Typography>

            {description && (
                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 500, mb: action ? 3 : 0 }}>
                    {description}
                </Typography>
            )}

            {action && (
                <Box sx={{ mt: 2 }}>
                    {action}
                </Box>
            )}
        </Paper>
    );
};

export default EmptyState;